<template>
<div>Recommendations</div>
</template>
<script>
</script>